/**
 * Shared constants for mood detection
 */

// Export mood categories for consistent use across the app
export const MOOD_CATEGORIES = {
  ANXIOUS: 'anxious',
  CALM: 'calm',
  HAPPY: 'happy',
  SAD: 'sad',
  ENERGETIC: 'energetic',
  STUDY: 'study',
  SOOTHING: 'soothing',
  ANGRY: 'angry',
  FOCUSED: 'focused'
};

// Export detection types
export const DETECTION_TYPES = {
  EMOJI: 'emoji',
  CHAT: 'chat'
};
